var _react_refresh_temp_1;
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@lucidlink/uicore';
import { AppGuestHeader } from './components';
import styles from './GuestHeaderLayout.module.css';
export const GuestHeaderLayout = ({ children }) => (_jsxs(_Fragment, { children: [_jsx(AppGuestHeader, {}), _jsx(Box, { align: "center", className: styles.MainContent, isFullHeight: true, isFullWidth: true, justify: "center", orientation: "vertical", scrollableY: true, children: children })] }));
_react_refresh_temp_1 = GuestHeaderLayout;
$RefreshReg$(_react_refresh_temp_1, "GuestHeaderLayout");
